import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_URL,
  timeout: 300000, // 5 minutes default timeout
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor to handle multipart/form-data
api.interceptors.request.use(
  (config) => {
    // Don't set Content-Type for multipart/form-data, let browser set it
    if (config.headers["Content-Type"] === "multipart/form-data") {
      delete config.headers["Content-Type"];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for better error handling
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Don't log canceled requests as they are normal behavior
    if (error.code !== "ERR_CANCELED") {
      console.error("API Error:", error);
    }
    return Promise.reject(error);
  }
);

export default api;
